/* tslint:disable jsx-no-lambda */
import * as React from 'react'
import AssistanceTypes from './AssistanceTypes'
import Hearing from '../icons/ui/Hearing'
import Mobility from '../icons/ui/Mobility'
import Vision from '../icons/ui/Vision'
import Speakers from '../icons/ui/Speakers'
import { Link } from 'react-router-dom'
import Edit from 'src/components/icons/ui/Pencil'

class AssignTripPassenger extends React.Component<any, any> {
  constructor(props: any) {
    super(props)
    this.state = {}
  }
  public render() {
    return <div>{this.renderSetPassengerLink()}</div>
  }

  private renderSetPassengerLink = () => {
    return (
      <Link className='assign-trip-link' to={`${this.props.actionUrl}/passengers`}>
        <div title={`Passengers`} className='h6 font-green weight-400'>
          <Edit className='icon--12x12 cursor--pointer' />
        </div>
      </Link>
    )
  }
}

export default AssignTripPassenger



// WEBPACK FOOTER //
// ./src/components/trips/AssignTripPassenger.tsx